<template>
  <div>
    <a-steps  direction="vertical">
      <a-step v-for="item in processList" :key="item.taskDefinitionKey">
        <template  #icon>
          <div class="avatar">
            <img :src="item.avatarUrl" v-if="item.avatarUrl" class="avatar-icon" />
            <div v-else  class="no-picture avatar-icon">{{item.userName}}</div>
          </div>
        </template>

        <template #title>
          <div class="process-content">
            <div class="process-title">
              <div class="title">
                <slot name="titleName" :dataSource="item">
                  <span class="title-name">{{ item.actionName }}</span>
                </slot>
                <!-- <span class="title-name" v-if="item.taskName!==item.actionName&&item.actionName">({{ item.actionName }})</span> -->
                <span class="audit-desc" v-if="item.signType != null && item.signType == 1 && item.taskInfoItemList.length>1">（多处理人全部处理）</span>
                <span class="audit-desc" v-else-if="item.signType != null && item.signType == 2 && item.taskInfoItemList.length>1">（多处理人任意一人处理）</span>
              </div>
              <!-- type==2为审批类型,4:抄送 -->
              <div class="endTime" v-if="item.type!==2&&item.type!==4">{{ item.endTime }}</div>
            </div>
            <div class="person-msg">
              <span v-if="item.type!==2">{{ item.userName }}</span>
              <!-- <div v-else>
                <span v-for="(taskInfoItem,taskInfoIndex) in item.taskInfoItemList" :key="taskInfoItem.jobNo">
                <span>{{taskInfoItem.userName}}</span><span v-if="taskInfoItem.actionName" :class="taskInfoStatus(taskInfoItem.actionName)">（{{taskInfoItem.actionName}}）</span><span v-if="taskInfoIndex!==item.taskInfoItemList.length-1">，</span>
                </span>
                <span v-if="item.signType != null && item.signType == 1 && item.taskInfoItemList.length>1">，(多处理人全部处理)</span>
                <span v-else-if="item.signType != null && item.signType == 2 && item.taskInfoItemList.length>1">，(多处理人任意一人处理)</span>
              </div> -->
            </div>
          </div>
        </template>
        <template #description>
          <div v-if="item.type==2" class="task-Info-comment">
            <div v-for="(taskInfoItem, taskIndex) in item.taskInfoItemList" :key="(taskInfoItem.jobNo + taskIndex)" class="task-info-item">
              <div >
                <div class="task-info-item-label" >
                  <div>
                    <span>{{taskInfoItem.userName}}</span>
                    <span v-if="taskInfoItem.actionName||taskInfoItem.actionResult" :class="taskInfoStatus(taskInfoItem.actionResult||taskInfoItem.actionName)">（{{taskInfoItem.actionResult||taskInfoItem.actionName}}）</span>
                  </div>
                  <span>{{taskInfoItem.endTime}}</span>
                </div>
                <div class="comment" v-if="taskInfoItem.comment||(taskInfoItem.attachmentList&&taskInfoItem.attachmentList.length>0)">
                  <div class="comment-text">{{ taskInfoItem.comment }}</div>
                  <div class="file-list" v-if="taskInfoItem.attachmentList&&taskInfoItem.attachmentList.length>0">
                    <p class="comment-text">附件：</p>
                    <ls-image-upload
                        :file-list="taskInfoItem.attachmentList"
                        :need-tip="false"
                        :need-delect="false"
                        :un-upload="true"
                        :need-down="true"
                        file-path="url"
                        show-name
                        :iconType="iconType"
                        :size="88"
                        fileName="name"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="comment" v-else-if="item.comment||item.attachmentList&&item.attachmentList.length>0||item.copyUserItemList&&item.copyUserItemList.length>0">
            <!--非抄送人 -->
            <template v-if="item.type !== 4">
              <div class="comment-text">{{ item.comment }}</div>
              <div class="file-list" v-if="item.attachmentList&&item.attachmentList.length>0">
                <p>附件：</p>
                <ls-image-upload
                    :file-list="item.attachmentList"
                    :need-tip="false"
                    :need-delect="false"
                    :un-upload="true"
                    :need-down="true"
                    file-path="url"
                    :iconType="iconType"
                    :size="88"
                    fileName="name"
                />
              </div>
            </template>
            <!--抄送人 -->
            <template v-else>
              <div v-if="item.copyUserItemList && item.copyUserItemList.length > 0">
                <div class="copy-user-msg">
                  <span class="copy-read">已抄送{{item.copyUserItemList.length}}人，</span>
                  <span class="copy-no-read">{{readCount(item.copyUserItemList)}}人已读</span>
                </div>
                <div
                    class="copy-user-list"
                >
                  <div
                      v-for="(subItem, userIndex) in item.copyUserItemList"
                      :key="(subItem.jobNo + userIndex)"
                      class="copy-user-item"
                  >
                    <div class="copy-user-avatar">
                      <img :src="subItem.avatarUrl"  class="avatar-photo" />
                      <img :src="readIcon"  class="avatar-read" v-if="subItem.readStatus" />
                    </div>
                    <div>{{ subItem.userName }}</div>
                  </div
                  >
                </div>
              </div>

            </template>
          </div>
        </template>
      </a-step>
    </a-steps>
  </div>
</template>
<script>
// import Cookies from "js-cookie";
import { apiGetBpmLogs } from "@/services/module/base";
export default {
  name: 'ProcessLog',
  props: {
    api: {
      type: Function,
      default: apiGetBpmLogs
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      billData: {
        fileList: [],
        letterContent: ''
      },
      iconType: {
        excel: 'file-text',
        pdf: 'file-text',
        word: 'file-text',
        video: 'file-text',
        other: 'file-text',
        fail: 'file-text'
      },
      processList: []
      // jobNo: Cookies.get("jobNo"),
      // userName: Cookies.get('user')
    }
  },
  mounted() {
    this.getProcessData()
  },
  methods: {
    getProcessData() {
        this.api(this.params).then(res => {
        if(res.state === 100) {
          console.log(res.data)
          this.processList = res.data || []
        }
      })
    },
    taskInfoStatus(data) {
      if(data === '已同意') {
        return 'agree-process'
      }else if(data === '不同意' || data === '驳回') {
        return 'no-agree-process'
      }else{
        return null
      }
    }
  }
}
</script>
<style lang="less" scoped>
.title-content{
  text-align: center;
  font-size: 20px;
}
.margin-8{
  margin: 8px !important;
}
.loading-content{
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(240, 240, 240, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.process-content {
  margin-left: 4px;
  .process-title {
    display:flex;
    justify-content: space-between;
    margin-bottom:6px;
    .title{
      .title-name{
        font-size: 14px;
        color: #000000;
        font-weight:bold;
      }
      .audit-desc{
        font-size:13px;
        font-weight:0;
        color: #97A0AD;
      }
    }
    .endTime{
      flex:50px;
      font-size: 12px;
      color:#97A0AD;
      text-align:right;
    }
  }
  .person-msg {
    color: #17191C;
    font-size: 12px;
    margin-bottom:8px;
  }
}
.avatar {
  flex: 20px;
  position:relative;
  .avatar-icon {
    width: 30px;
    height: 30px;
    border-radius: 15px;
  }
  .no-picture{
    // position:relative;
    line-height: 30px;
    border-radius:15px;
    background-color:#0486fe;
    color: #fff;
    text-align: center;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break:break-all;
  }
  .audit-endIs{
    position:absolute;
    right:0;
    bottom:0;
    background-color:#fff;
    border-radius:15px;
  }
}
.task-Info-comment{
  .task-info-item{
    margin-bottom:12px;
    .task-info-item-label{
      font-size:12px;
      display:flex;
      justify-content:space-between;
    }
  }

}
.comment {
  background-color: #F6F7F9;
  color: #000000;
  padding: 8px 12px;
  border-radius: 5px;
  .comment-text {
    margin-bottom: 2px;
    font-size: 12px;
    color:rgba(0,0,0,0.64)
  }
  .file-list {
    font-size: 12px;
  }
  .copy-user-msg{
    margin-bottom:8px;
    font-size:12px;
    .copy-read{
      color:#97A0AD
    }
    .copy-no-read{
      color:#2984FE
    }
  }
  .copy-user-list{
    display:flex;
    .copy-user-item{
      display:flex;
      flex-direction:column;
      align-items:center;
      font-size:12px;
      margin-right:8px;
      .copy-user-avatar{
        position:relative;
        .avatar-photo{
          border-radius: 12px;
          width:25px;
          height:25px;
        }
        .avatar-read{
          position:absolute;
          right:-3px;
          bottom:0
        }
      }
    }
  }
}
.agree-process{
  color:green;
}
.no-agree-process{
  color:red;
}
.no-data-loading{
  text-align:center;
}
/deep/ .ant-steps-item-title{
  width: 100%;
}
.footer{
  font-size: 12px;
  color: #4d7787;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  padding-top: 8px;
}
.font-size-14{
  /deep/ .title-content-layout-first{
    font-size: 14px;
  }
}
</style>
